/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import UIStrings from '../../../constants/UIStrings';
import DirectoryList from '../../DirectoryList/DirectoryList';
import React from 'react';
import { ROUTE_NAMES } from '../../../routerConfig/routeNames/routeNames';
import DirectoryPage from '../../DirectoryPage/DirectoryPage';


export default function AdminSystemDirectoryPage() {
  const ADMIN = ROUTE_NAMES.ADMIN;

  return (
      <DirectoryPage
          routeName={ADMIN.SYSTEM.DIRECTORY}
          text={UIStrings.ADMIN_SYSTEM_DIRECTORY.MENU.text}
          description={UIStrings.ADMIN_SYSTEM_DIRECTORY.MENU.description}
      >
        <DirectoryList>
         <DirectoryList.DirectoryListItem
              data-analytics-id="nxrm-admin-system-directory-api-lnk"
              text={UIStrings.API.MENU.text}
              description={UIStrings.API.MENU.description}
              routeName={ADMIN.SYSTEM.API}
          />

          <DirectoryList.DirectoryListItem
              data-analytics-id="nxrm-admin-system-directory-capabilities-lnk"
              text={UIStrings.CAPABILITIES.MENU.text}
              description={UIStrings.CAPABILITIES.MENU.description}
              routeName={ADMIN.SYSTEM.CAPABILITIES}
              params={{ id: null }}
          />

          <DirectoryList.DirectoryListItem
              data-analytics-id="nxrm-admin-system-directory-email-server-lnk"
              text={UIStrings.EMAIL_SERVER.MENU.text}
              description={UIStrings.EMAIL_SERVER.MENU.description}
              routeName={ADMIN.SYSTEM.EMAILSERVER}
          />


          <DirectoryList.DirectoryListItem
              data-analytics-id="nxrm-admin-system-directory-http-lnk"
              text={UIStrings.HTTP.MENU.text}
              description={UIStrings.HTTP.MENU.description}
              routeName={ADMIN.SYSTEM.HTTP}
          />

          <DirectoryList.DirectoryListItem
              data-analytics-id="nxrm-admin-system-directory-licensing-lnk"
              text={UIStrings.LICENSING.MENU.text}
              description={UIStrings.LICENSING.MENU.description}
              routeName={ADMIN.SYSTEM.LICENSING}
          />

          <DirectoryList.DirectoryListItem
              data-analytics-id="nxrm-admin-system-directory-nodes-lnk"
              text={UIStrings.NODES.MENU.text}
              description={UIStrings.NODES.MENU.description}
              routeName={ADMIN.SYSTEM.NODES}
          />

          <DirectoryList.DirectoryListItem
              data-analytics-id="nxrm-admin-system-directory-tasks-lnk"
              text={UIStrings.TASKS.MENU.text}
              description={UIStrings.TASKS.MENU.description}
              routeName={ADMIN.SYSTEM.TASKS}
              params={{ taskId: null }}
          />

          <DirectoryList.DirectoryListItem
              data-analytics-id="nxrm-admin-system-directory-upgrade-lnk"
              text={UIStrings.UPGRADE.MENU.text}
              description={UIStrings.UPGRADE.MENU.description}
              routeName={ADMIN.SYSTEM.UPGRADE}
          />
        </DirectoryList>
      </DirectoryPage>);
}
